<template>
  <div v-show="warrantyPriceText && !isHygiene" class="warranty-card" @click="toggle">
    <div class="warranty-card__button p-2">
      <div class="label-container-checkbox d-flex">
        <img :src="$root.cdn_url + '/assets/images/fa/fa-arrow-right-red.svg'" class="slide-right fa-arrow-right mt-1" width="16" style="align-self:start;">
        <span class="warranty-card__button__title">
          {{ textWarrantyTitle }}
        </span>
        <span class="checkmark" :class="{ active: form.isWarrantyChecked }"></span>
      </div>
    </div>
    <div class="d-flex mt-2">
      <div class="flex-shrink-0 pr-2 pt-3">
        <img class="warranty-card__icon lazy" :src="imageWarranty" alt="" />
      </div>
      <div class="warranty-card__text">
        <h4>{{ textWarrentySubtitle }}</h4>
        {{ textWarrentyText }}
      </div>
    </div>
  </div>
</template>

<script>
import globals from "../../mixins/globals";
import { t } from "../../utils/i18n";

export default {
  name: "WarrantyZMC10",

  props: ["form"],

  mixins: [globals],

  mounted() {
    this.lazyload_update();
  },

  updated() {
    this.lazyload_update();
  },

  computed: {
    quantityOfInstallments() {
      return this.form.installments !== 1 ? this.form.installments + "× " : "";
    },

    warrantyPriceText() {
      const prices = js_data.product.prices;

      if (!this.form.deal) {
        return 0;
      }

      switch (this.form.installments) {
        case 1:
          return prices[this.form.deal].warranty_price_text;
        case 3:
          return prices[this.form.deal].installments3_warranty_price_text ? '3× ' + prices[this.form.deal].installments3_warranty_price_text : 0;
        case 6:
          return prices[this.form.deal].installments6_warranty_price_text ? '6× ' + prices[this.form.deal].installments6_warranty_price_text : 0;
      }

      return 0;
    },

    isHygiene() {
      return js_data.product.is_hygiene;
    },

    textWarrantyTitle: function() {
      return this.$t("checkout.warranty.title", { "PRICE": this.warrantyPriceText || '' });
    },
    textWarrentySubtitle: () => t("checkout.warranty.special_offer_title"),
    textWarrentyText: function() {
      return this.$t("checkout.warranty.special_offer_desciprion", { "PRICE": this.warrantyPriceText || '' });
    },
    imageWarranty() {
      return this.$root.cdn_url + "/assets/images/zmc10/warranty.png";
    },
    imageVerifiedCheck() {
      return this.$root.cdn_url + "/assets/images/zmc10/check.svg";
    }
  },

  methods: {
    toggle() {
      this.form.isWarrantyChecked = !this.form.isWarrantyChecked;
    }
  }
};
</script>

<style lang="scss" scoped>
.warranty-card {
  background: #fbf8ec;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  padding: 7px;
  cursor: pointer;

  &__button {
    background: #f5d762;
    border-radius: 3px;

    &__title {
      margin-left: 45px;
    }

    .label-container-checkbox {
      font-family: Roboto, sans-serif;
      font-weight: 600;
      font-size: 18px;
      line-height: 30px;
      color: #212d3d;
      margin-bottom: 0;
      padding-left: 0;
    }

    .checkmark {
      margin-top: 5px;
      margin-left: 30px;

      // customize checkmark with custom icon
      &:after {
        background-image: url("data:image/svg+xml,%3Csvg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.192383 10.115C0.192383 10.115 3.07238 13.3575 3.64738 14.682H6.12238C7.15988 11.5145 11.1899 3.9545 14.6454 1.3045C15.3604 0.384503 13.5629 0.00450286 12.1116 0.614003C9.92413 1.5315 5.79913 8.544 5.02913 10.23C3.93663 10.5175 2.78413 8.3875 2.78313 8.3875L0.192383 10.115Z' fill='%2316A085'/%3E%3C/svg%3E%0A");
        background-size: contain;
        background-repeat: no-repeat;
        width: 24px;
        height: 24px;
        border: 0;
        transform: none;
        top: -8px;
        left: -2px;
      }
    }
  }

  &__text {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;
    color: #212d3d;

    h4 {
      font-style: italic;
      font-weight: 600;
      font-size: 19px;
      line-height: 24px;
      text-decoration-line: underline;
      text-transform: uppercase;
      color: #ff0000;
      margin-bottom: 3px;
    }
  }

  &__icon {
    width: 86px;
    height: 86px;
  }

  @media (max-width: 768px) {
    .label-container-checkbox {
      font-weight: 600;
      font-size: 16px;
      line-height: 30px;
    }
  }
}
</style>
